<template>
  <div class="v2-table__empty-data">
    <div class="v2-table__empty-default">
      <div class="v2-table__empty-icon mauto">
        <div class="v2-table__icon--inner">
          <span class="inner-rect"></span>
          <span class="inner-horizontal-line inner-line1"></span>
          <span class="inner-horizontal-line inner-line2"></span>
          <span class="inner-horizontal-line inner-line3"></span>
          <span class="inner-circle"></span>
        </div>
      </div>
      <span class="v2-table__empty-text">{{noData}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'compinents-custom-empty-hint',
    props: {
      noData: {
        type: String,
        default: '暂无数据'
      }
    }
  }
</script>

<style lang='scss' scoped>
  .v2-table__empty-data{
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    background-color: #fff;
  }
  .v2-table__empty-icon{
    background-color: rgba(0, 0, 0, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/empty-hint/empty-hint.vue